import React from 'react';

import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem, Card, CardHeader, ListGroup, ListGroupItem, Row, Col, Table,
} from 'reactstrap';
import { useNavigate, useLocation } from "react-router-dom";

const CertificateInformation13 = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const coursetrack = location.state ? location.state.courseTrack : "";
    const coursename = location.state ? location.state.courseName : "";
    const [open, setOpen] = React.useState(['7']); // Initialize open state with an empty array

    const toggle = (id) => {
        setOpen(prevOpen => {
            if (prevOpen.includes(id)) {
                // If the section is already open, remove it from the open state
                return prevOpen.filter(item => item !== id);
            } else {
                // If the section is not open, add it to the open state
                return [...prevOpen, id];
            }
        });
    };
    const handleEnrollClick = () => {

        navigate("/application-form", {
            state: {
                courseTrack: coursetrack,
                courseName: coursename,

            },
        });
    };
    return (
        <>




        <div className="container mt-1 p-3 mb-1" >



            <Row>
                <Col>
                    <h2 className=" text-center" style={{ color: '#123fae' }}>
                        Certificate Course in Web Designing
                        {/* <a href='a'
                            style={{ float: "right", fontSize: 15, color: "#e74c3c" }}
                            className="d-block mx-auto"
                            onClick={(event) => {
                                event.preventDefault(); // Prevents the default behavior (page reload)
                                handleEnrollClick(); // Calls your handleEnrollClick function
                            }}
                        >
                            Register Now
                        </a> */}

                    </h2>




                </Col>
            </Row>

            {/* <h4>Course Details:</h4> */}
            <Row>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card >
                        <CardHeader>
                            Course Details:
                        </CardHeader>




                        <ListGroup flush >

                            <ListGroupItem>
                                Language: English
                            </ListGroupItem>
                            <ListGroupItem>
                                Duration: 120 hours (3 months)
                            </ListGroupItem>
                            <ListGroupItem>
                                Learning Mode: Online
                            </ListGroupItem>
                            <ListGroupItem>
                                Certificate of Completion
                            </ListGroupItem>


                        </ListGroup>
                    </Card  ></Col>
                <Col md={6} xs={12} className="mt-3 ">
                    <Card style={{ minHeight: "100%"}}>
                        <CardHeader >
                            Eligibility:
                        </CardHeader>




                        <ListGroup flush className="px-2">

                            <ListGroupItem>
                                <li> Learner should preferably be a 12th std. Pass student.</li>

                            </ListGroupItem>

                        </ListGroup>
                    </Card></Col>
            </Row>
            <br />
            <hr />
            <div >
                <h5 style={{ position: "relative" }}>
                    <span >
                        &#x1F449;
                    </span>
                    Why Certificate Course in Web Designing
                </h5>
                <p>
                    A web designer is essentially in a supporting role. He / She is supposed to have sound knowledge of design fundamentals and web production techniques. He / She is involved in the project at every stage, so that he / she understands the whole project cycle.</p>


            </div>
            <hr />

            <h5 style={{ position: "relative" }}>

                What does a Web Designer Do?
            </h5>
            <p>A web designer performs following functions:</p>
            <ul>
                <li>Assists in project conceptualization</li>
                <li>Creates workflows for developers and clients</li>
                <li>Follows brand identity norms</li>
                <li>Makes effective use of typography and images</li>
                <li>Creates digital advertising assets (like banners, rollovers etc.)</li>

            </ul>
            <hr></hr>




            <h5 style={{ position: "relative" }}>

                What you'll learn ?
            </h5>

            <p>A web designing firm, IT companies or an advertising agency is one of the best places for a web designer, though he / she can also work with companies/enterprises working in multimedia, eLearning and gaming industry.</p>
            <p>He / She can do a job or can work as a freelance designer. A fresher can draw up to Rs. 1.2 – 1.4 Lacs p.a.</p>
            <hr></hr>

            <h5 style={{ position: "relative" }}>

                Hierarchy
            </h5>

            <ul>
                <p>He / She would work with a team of web designers and a creative director who would guide them. Typically, he / she would be a part of graphic designing / digital creations / content development team. He / She can further pursue to become a senior web designer or a User Interface / Experience designer as per his/her liking and abilities.  </p>
            </ul>
            <hr />
            <h5 style={{ position: "relative" }}>

                Tools
            </h5>
            <ul>
                <p>Typically, a junior web designer uses tools like Adobe Dreamweaver, Adobe Flash, Adobe Photoshop. Knowledge of few other skills like JQuery, JQuery Mobile, and responsive web design will be an additional advantage for him/her.  </p>
            </ul>
            <hr />





            <div >
                <h5 style={{ left: "0" }}>Certification</h5>
                <ul><li> Web Designing course is jointly certified by CDOE GJUST and HKCL.</li>
                </ul>

            </div>
            <hr />
            
            <div >
                <h5 style={{ left: "0" }}>Academic Approach</h5>
                <p>
                    The academic approach of the courses focuses on the “work-centric” education i.e. begin with work (and not from a book!), derive knowledge from work and apply that knowledge to make the work more wholesome, useful and delightful. The ultimate objective is to empower the Learner to engage in socially useful and productive work. It aims at leading the learner to his/her rewarding career as an employee or entrepreneur as well as development of the community to which s/he belongs.
                    Learning methodology:
                </p>


                <ul>
                    <li>Step -1: Learners are given an overview of the course and its connection to life and work.</li>
                    <li>Step -2: Learners are exposed to the specific tool(s) used in the course through the various real-life applications of the tool(s).</li>
                    <li>Step -3: Learners are acquainted with the careers and the hierarchy of roles they can perform at workplaces after attaining increasing levels of mastery over the tool(s).</li>
                    <li>Step -4: Learners are acquainted with the architecture of the tool or tool map so as to appreciate various parts of the tool, their functions, utility and inter-relations.</li>
                    <li>Step -5: Learners are exposed to simple application development methodology by using the tool at the beginner’s level.</li>
                    <li>Step -6: Learners perform the differential skills related to the use of the tool to improve the given ready-made industry-standard outputs.</li>
                    <li>Step -7: Learners are engaged in appreciation of real-life case studies developed by the experts.</li>
                    <li>Step -8: Learners are encouraged to proceed from appreciation to imitation of the experts.</li>
                    <li>Step -9: After the imitation experience, they are required to improve the expert’s outputs so that they proceed from mere imitation to emulation.</li>
                    <li>Step -10: Emulation is taken a level further from working with differential skills towards the visualization and creation of a complete output according to the requirements provided. (Long Assignments)</li>
                    <li>Step -11: Understanding the requirements, communicating one’s own thoughts and presenting are important skills required in facing an interview for securing a work order/job. For instilling these skills, learners are presented with various subject-specific technical as well as HR-oriented questions and encouraged to answer them.</li>
                    <li>Step -12: Finally, they develop the integral skills involving optimal methods and best practices to produce useful outputs right from scratch, publish them in their ePortfolio and thereby proceed from emulation to self-expression, from self-expression to self-confidence and from self-confidence to self-reliance and self-esteem!</li>
                </ul>
            </div>
            <hr />
            <div >
                <h5 style={{ left: "0" }}>Admission Guidelines</h5>
                <p>
                  
                    <li>
            <b>Online Registration: </b> Learner needs to visit <a href="https://www.gjuskillcourses.hkcl.in">www.gjuskillcourses.hkcl.in</a> and make an online payment for admission confirmation. Kindly refer online admission process guidelines for more details.
          </li>
                </p>
            </div>
            <hr />

            <h5>Syllabus</h5>

            <div className='p-4' >



                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="7"> web Designing-Course Introduction</AccordionHeader>
                        <AccordionBody accordionId="7">
                            <ul>
                                <li> Understanding the World of Designing</li>
                                <li>Understanding colors and related concepts</li>
                                <li>Getting introduced to typography and colors</li>
                                <li>Learning how to write and build content</li>
                                <li>Understanding what Client Briefs, Storyboards, Visual Mind Maps, and Marketing Plans</li>
                                <li>Learning more about client briefs, Storyboards, Visual Mind Maps, etc.</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="8">Designs and shapes</AccordionHeader>
                        <AccordionBody accordionId="8">
                            <ul>
                                <li>Learning about various designs and shapes</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="9">Basics of designs and shapes</AccordionHeader>
                        <AccordionBody accordionId="9">
                            <ul>
                                <li>Understanding the basics of designs and shapes</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="10">Basics of web designing</AccordionHeader>
                        <AccordionBody accordionId="10">
                            <ul>
                                <li>Learning the basics of web designing</li>
                                <li> Learning to create a few website elements</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="11">Typography</AccordionHeader>
                        <AccordionBody accordionId="11">
                            <ul>
                                <li>Understanding the rules and guidelines for typography</li>
                                <li>Using Fonts and optimizing typography</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="13">Color schemes</AccordionHeader>
                        <AccordionBody accordionId="13">
                            <ul>
                                <li>Identifying color schemes and combinations</li>
                                <li>Exploring more about colors and the trends</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="14">Adobe Bridge</AccordionHeader>
                        <AccordionBody accordionId="14">
                            <ul>
                                <li>Learning the basics of Adobe Bridge</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="15">Effects in Adobe PhotoShop</AccordionHeader>
                        <AccordionBody accordionId="15">
                            <ul>
                                <li> Creating web-ready images by applying various effects in Adobe Photoshop</li>
                                <li> Learning about a tool and creating a web layout in Adobe Photoshop</li>
                                <li>Learning to automate and mask an image in Adobe Photoshop</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>


                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="16">Site and wireframe</AccordionHeader>
                        <AccordionBody accordionId="16">
                            <ul>
                                <li>Learning to create a sitemap and wireframe for a website</li>
                                <li> Identifying how and where to use a website wireframe</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>




                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="17">Copyright-free images</AccordionHeader>
                        <AccordionBody accordionId="17">
                            <ul>
                                <li> Searching, downloading, and using free and copyright-free images</li>
                                <li>Exploring stock platforms for images</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>



                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="18">Web designing tools</AccordionHeader>
                        <AccordionBody accordionId="18">
                            <ul>
                                <li>Exploring the popular web designing tools</li>
                                <li>Studying more about the web designing tools</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>


                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="19">Figma</AccordionHeader>
                        <AccordionBody accordionId="19">
                            <ul>
                                <li>Designing a user interface using Figma</li>
                                <li>Adding content in the user interface using Figma</li>
                                <li> Creating and working on a project in Figma</li>
                                <li>Working with components and applying constraints in Figma</li>
                                <li>Working with plugins in Figma</li>
                                <li>Learning to prototype, share, and export a file in Figma</li>
                                <li>Executing to prototype, share, and export a file in Figma</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="20">UI,layouting, and grids</AccordionHeader>
                        <AccordionBody accordionId="20">
                            <ul>
                                <li>Learning about UI, layouting, and grids</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>



                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="21">Understanding UI and UX</AccordionHeader>
                        <AccordionBody accordionId="21">
                            <ul>
                                <li>Understanding what is UI and UX</li>
                                <li>Exploring the field of UX and the 4 C's of designing</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>


                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="22">Smart and efficient working</AccordionHeader>
                        <AccordionBody accordionId="22">
                            <ul>
                                <li>  Exploring the competencies and techniques for smart and efficient workingExploring the competencies and techniques for smart and efficient working</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="23">Internet and related concepts</AccordionHeader>
                        <AccordionBody accordionId="23">
                            <ul>
                                <li>Learning the basics of the Internet and related concepts</li>
                                <li>Learning about browsers</li>
                                <li>Understanding what a website and Email Client</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>


                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="24">Adobe Dreamweaver</AccordionHeader>
                        <AccordionBody accordionId="24">
                            <ul>
                                <li> Exploring more about web designing and new features of Adobe Dreamweaver</li>
                                <li>Using new features of Adobe Dreamweaver and discovering what a responsive website is</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>


                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="25">HTML</AccordionHeader>
                        <AccordionBody accordionId="25">
                            <ul>
                                <li>Learning the basics of HTML</li>
                                <li>Exploring different types of Tags in HTML</li>
                                <li> Working with texts and links in HTML</li>
                                <li>Working with images in HTML</li>
                                <li>Exploring the forms and understanding what XHTML is</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>


                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="26">HTML and CSS-Case study</AccordionHeader>
                        <AccordionBody accordionId="26">
                            <ul>
                                <li> Creating webpage using HTML and CSS</li>
                                <li> Creating Navigation bar using CSS</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="27">HTML5 and CSS3</AccordionHeader>
                        <AccordionBody accordionId="27">
                            <ul>
                                <li>Creating impressive webpages using HTML5, and CSS3</li>
                                <li>Exploring and applying CSS Styles</li>
                                <li>Working with CSS rules and AP elements</li>
                                <li>Exploring what CSS3 is and using the CSS Designer Panel</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="28">JavaScript</AccordionHeader>
                        <AccordionBody accordionId="28">
                            <ul>
                                <li>Learning about JavaScript (Hello world! and variables)</li>
                                <li>Learning about JavaScript (Conditional statements)</li>
                                <li>Learning about JavaScript (JS loops)</li>
                                <li>Learning about JavaScript (JS project)</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="29">jQuery</AccordionHeader>
                        <AccordionBody accordionId="29">
                            <ul>
                                <li>Introduction to jQuery</li>
                                <li>Learning more about jQuery</li>
                                <li>Understanding the Events</li>
                                <li>Understanding the animation effects and DOM Traversal and manipulation in jQuery Bootstrap</li>
                                <li>Understanding what a responsive web design is and developing it using Bootstrap</li>
                                <li>Exploring the components of Bootstrap</li>
                                <li>Discovering what Forms, Breakpoints, and Containers in Bootstrap are</li>
                                <li>Understanding what Grid System is in Bootstrap</li>
                                <li> Working with typography and images in Bootstrap</li>
                                <li>Exploring the new concepts of typography and images while working in Bootstrap</li>
                                <li>Learning about the Bootstrap Homepage and other elements</li>
                                <li>Exploring more about the Bootstrap</li>
                                <li>Discovering and working with the About page in Bootstrap</li>
                                <li>Discovering and working with the Contact page in Bootstrap</li>
                                <li>Creating interactive buttons using Bootstrap</li>
                                <li>Identifying various parts of a website and more</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>


                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="30">PHP</AccordionHeader>
                        <AccordionBody accordionId="30">
                            <ul>
                                <li>Getting introduced to what PHP is, its requirements, and creating a PHP file</li>
                                <li>Working with PHP variables, operators, and statements</li>
                                <li>Working with PHP loops, arrays, and more</li>
                                <li>Learning the types of functions in PHP</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="31">MySQL</AccordionHeader>
                        <AccordionBody accordionId="31">
                            <ul>
                                <li> Understanding the MySQL Databases and firebases</li>
                                <li>Working with MySQL commands, databases, and statements</li>
                                <li>Working with indexes and views, statements, and keywords in MySQL</li>
                                <li>Exploring the procedures and types of Joins in MySQL</li>
                                <li>Getting introduced to Firebase</li>
                                <li>Authenticating Firebase and defining the project settings</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="32">Designing a responsive website</AccordionHeader>
                        <AccordionBody accordionId="32">
                            <ul>
                                <li> Designing a responsive website using Adobe Dreamweaver</li>
                                <li>Designing and editing a responsive website using Adobe Dreamweaver</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="33">Fluid Grid Layout-Case Study</AccordionHeader>
                        <AccordionBody accordionId="33">
                            <ul>
                                <li>Designing a website using CSS3 and applying the Fluid Grid Layout</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>


                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="34">Product-based website-Case Study</AccordionHeader>
                        <AccordionBody accordionId="34">
                            <ul>
                                <li>Designing a wireframe for a product-based website - Case Study</li>
                                <li>Using WordPress to design a product-based website - Case Study</li>
                                <li>Customizing and completing a product-based website - Case Study</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="35">Social media website-Case Study</AccordionHeader>
                        <AccordionBody accordionId="35">
                            <ul>
                                <li>Starting with designing a social media website - Case Study</li>
                                <li>Setting and customizing a social media website - Case Study</li>
                                <li>Customizing a social media website - Case Study</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="36">Website for a news channel-Case Study</AccordionHeader>
                        <AccordionBody accordionId="36">
                            <ul>
                                <li>Setting and adding pages to a website for a news channel - Case Study</li>
                                <li>Customizing and post news on a website for a news channel - Case Study</li>
                                <li>Posting and reviewing news articles on a website for a news channel - Case Study</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="37">WordPress</AccordionHeader>
                        <AccordionBody accordionId="37">
                            <ul>
                                <li>Designing an eCommerce website using WordPress</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="38">WordPress</AccordionHeader>
                        <AccordionBody accordionId="38">
                            <ul>
                                <li>Creating a wireframe for a service-based website - Case Study</li>
                                <li>Setting up and arranging content for an service-based website - Case Study</li>
                                <li>Formatting and reviewing an service-based website - Case Study</li>
                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="39">eLearning company website-Case Study</AccordionHeader>
                        <AccordionBody accordionId="39">
                            <ul>
                                <li> Beginning to design a website for an eLearning company - Case Study</li>
                                <li> Creating and customizing pages in a website for an eLearning company - Case Study</li>
                                <li>Finalizing a website and buying a domain name for an eLearning company - Case Study</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>

                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="40">Wesite for an NGO-Case Study</AccordionHeader>
                        <AccordionBody accordionId="40">
                            <ul>
                                <li>Beginning to design a website for an NGO</li>
                                <li>Adding and customizing elements in a website for an NGO</li>
                                <li>Finalizing the website design for an NGO</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="41">CSS -Case Study</AccordionHeader>
                        <AccordionBody accordionId="41">
                            <ul>
                                <li>Designing a website using CSS - Case Study</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>


                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="42">Domains, and Web hosting</AccordionHeader>
                        <AccordionBody accordionId="42">
                            <ul>
                                <li>Starting with the basics of domains, and web hosting</li>
                                <li>Exploring more about web hosting and domain names</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>


                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="43">Project Cycles</AccordionHeader>
                        <AccordionBody accordionId="43">
                            <ul>
                                <li>Understanding what Project Cycles are</li>
                                <li>Discovering what Project Scope - Planning with the client</li>
                                <li>Discovering what Project Scope - Building, Optimization, Finalization</li>
                                <li>Discovering what Project Scope - Launch</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>
                <Accordion open={open} toggle={toggle} className="mb-2">
                    <AccordionItem >
                        <AccordionHeader targetId="44">Getting job-ready</AccordionHeader>
                        <AccordionBody accordionId="44">
                            <ul>
                                <li> Understanding more about the web designing field, processes, and getting job-ready</li>
                                <li> Exploring more about your career in web designing</li>
                                <li>Listing the types of web designers and how to create ideal resumes</li>
                                <li>Getting introduced to the world of employment</li>
                                <li>Understanding your options for career growth</li>
                                <li>Exploring various career-building options in web designing</li>

                            </ul>


                        </AccordionBody>
                    </AccordionItem>
                </Accordion>






            </div >
            <hr />
            <h5>Adobe Photoshop</h5>
            <p><b>Skills:</b>  Working Place, Customizing, Image and Color Modifications, Case Study - Black & White to Color, Using the Brush and Paint, Working with Selections, Scaling, Knowing the Layers, Filter Gallery, Color Adjustments</p>
            <p><b>Outputs:</b>Web Layout Design, Web Banner, Advertisement, UI Design

            </p>
            <hr></hr>
            <h4>Figma</h4>
            <p><b>Skills:</b>  Working Place, Customizing, Image and Color Modifications, Case Study - Black & White to Color, Using the Brush and Paint, Working with Selections, Scaling, Knowing the Layers, Filter Gallery, Color Adjustments</p>
            <hr></hr>

            <div style={{ overflowX: 'auto' }}>
        <h5>Evaluation Pattern</h5>
        <Table bordered striped >
          <thead>
            <tr>
              <th>Section No.</th>
              <th>Section Name</th>
              <th>Total Marks</th>
              <th>Minimum Passing Marks</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td>Learning Progression</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Internal Assessment</td>
              <td>25</td>
              <td>10</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Final Online Examination</td>
              <td>50</td>
              <td>20</td>
            </tr>
            <tr>
              <th colSpan="2" style={{ textAlign: "right" }}> Total</th>
              <th>100</th>
              <th>40</th>
            </tr>
            
          </tbody>
        </Table>
      </div>
      <hr />

      <div>
        <h5>Certificate of Completion</h5>
        <p>
          The certificate will be provided to the learner who will satisfy the below criteria:
        </p>
        
          <li>
            Learners who have successfully completed above mentioned 3 Sections i.e. Section 1, Section 2, and Section 3.
          </li>
          
        
      </div>
      <hr />
      <div>
        <h5>Fee Structure</h5>
        <p>Fee applicable from 2024 Batch onwards as mentioned below:</p>
        <Table bordered>
          <thead>
            <tr>
              <th>Mode</th>
              <th>Total Fee (Rupees)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Single Installment</td>
              <td>4500/-</td>
            </tr>
          </tbody>
        </Table>
        <p>Total fee is including of Course fees, Examination fees, and Certification fees.</p>
      </div>
     

      <li>
        <span style={{ color: 'red' }}>
         Additionally, the One Time Registration Fee is Rs. 100/-. </span>
      </li>
      


    </div >
    </>
    );
}
export default CertificateInformation13;